import { DWHAPI } from '../../apis/DWHAPI.js';

angular.module('harriApp')
    .factory('hEvent', ['$location', '$q', '$urlRouter', function($location, $q, $urlRouter) {
        var event = {};
        var isImpersonate;

        var isAnalyticsEnabled = function() {
            return !isImpersonate && publicConfiguration.isAnalyticsEnabled();
        };

        const executeAptrinsicEvent = (eventCallback) => {
            if (window.aptrinsic && typeof window.aptrinsic === 'function') {
                eventCallback();
            } else {
                window.aptrinsic('ready', function() {
                    eventCallback();
                });
            }
        };

        function convertForGA4(obj) {
            const result = {};

            for (const key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                const value = obj[key];

                if (
                    typeof value === 'string' ||
                    typeof value === 'number' ||
                    typeof value === 'boolean'
                ) {
                    result[key] = value;
                } else if (Array.isArray(value)) {
                    const flattened = value.map(v => {
                        if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
                            return v;
                        } else {
                            return JSON.stringify(v);
                        }
                    });
                    result[key] = flattened.join(',');
                } else if (typeof value === 'object' && value !== null) {
                    result[key] = JSON.stringify(value);
                } else {
                    result[key] = '';
                }
            }

            return result;
        };

        event.track = function(eventName, data, callback) {

            if (!isAnalyticsEnabled()) {
                return callback && callback();
            }

            if(!data) {
                data = {};
            }

            event.loadGoogleTagManager()
                .then(function (gtag) {
                    gtag('event', eventName, {
                        ...convertForGA4(data),
                        event_callback: callback
                    });
                });

            event.loadAptrinsic()
                .then(() => {
                    executeAptrinsicEvent(() => {
                        window.aptrinsic('track', eventName, data);
                    });
                });

            event.loadFacebookPixel()
                .then(() => {
                    window.fbq('trackCustom', eventName, data);
                });
        };

        event.dwhTrack = (eventName, data, callback) => {
            if (!isAnalyticsEnabled()) {
                return callback?.();
            }

            DWHAPI.trackEvent({
                event: eventName,
                ...data
            });
        };

        const identify = (data) => {
            event.loadGoogleTagManager()
                .then((gtag) => {
                    const {
                        user_id,
                        ...userProperties
                    } = data;

                    gtag('set', { 'user_id': user_id });

                    gtag('set', 'user_properties', convertForGA4(userProperties));
                });

            event.loadAptrinsic()
                .then(() => {
                    executeAptrinsicEvent(() => {
                        const userIdPrefix = EnvironmentsConfig.get('GainsightUserIdPrefix');
                        const gainsightData = {...data};
                        gainsightData['user_id'] =  gainsightData['id'] = userIdPrefix ? `${userIdPrefix}_${data['id']}` : data['id'];
                        window.aptrinsic('identify', gainsightData);
                    });
                });

            event.loadFacebookPixel()
                .then(() => {
                    window.fbq(`trackCustom`, `UserIdentified`, {
                        external_id: data['user_id'],
                        ...data
                    });
                });
        };

        event.identify = function(data) {
            var userToIdentify = angular.copy(data);
            isImpersonate = false;

            if (data && data.impersonate) {
                userToIdentify = {};
                isImpersonate = true;
            }

            const copy = {};
            for (const k in userToIdentify) {
                copy[k] = angular.copy(userToIdentify[k]);
            }

            if (userToIdentify.id) {

                if (userToIdentify['entry_mode']) {
                    copy['brand_id'] = userToIdentify['entry_mode']['brand_id'];
                    copy['brand_name'] = userToIdentify['entry_mode']['brand_name'];
                    copy['brand_type'] = userToIdentify['entry_mode']['brand_type'];
                }

                // remove sensitive data because it stores in local storage
                delete copy['email'];
                delete copy['phone'];
                delete copy['first_name'];
                delete copy['last_name'];

                identify({
                    user_id: userToIdentify.id,
                    ...copy
                });
                try {
                    window.ga('set', 'userId', userToIdentify.id.toString());
                }
                catch (e) {
                    console.error("Failed to set user id for Google Analytics, ga:", window.ga);
                }
            }
            else {
                event.reset();
            }
        };

        event.reset = function() {
            // Clear GTM dataLayer
            window.dataLayer = [];

            // This stops all GTM activity
            window['gtm.start'] = null;
            window.google_tag_manager = {};

            // This stops all aptrinsic activity
            typeof window.aptrinsic === 'function' && window.aptrinsic('reset');
            
            if (window.fbq) {
                window.fbq = null;
            }
        };

        var firstRequest = true;
        var lastPage;

        event.pageView = function(pageName, path, title, user_type) {

            if (!isAnalyticsEnabled()) {
                return;
            }

            const data = {
                title: title,
                url: window.location.protocol + "//" + window.location.host + path,
                path: path,
                user_type: user_type,
                category: 'page_views',
                label: path,
                referrer: window.referer
            };

            setTimeout(() => {
                firstRequest = false;

                if (window.location.pathname !== lastPage) {
                    event.loadGoogleTagManager()
                        .then((gtag) => {
                            gtag('event', 'page_view', data);
                        });
                    
                    event.loadAptrinsic()
                        .then(() => {
                            executeAptrinsicEvent(() => {
                                window.aptrinsic('track', 'PageView', data);
                            });
                        });
                        
                    event.loadFacebookPixel()
                        .then(() => {
                            window.fbq('track', 'PageView', data);
                        });

                    lastPage = window.location.pathname;
                }
            }, 2);
        };

        event.loadGoogleTagManagerPromise = null;

        event.loadGoogleTagManager = () => {
            if (event.loadGoogleTagManagerPromise) {
                return event.loadGoogleTagManagerPromise;
            }

            event.loadGoogleTagManagerPromise = new Promise(async (resolve) => {
                const gtmKey = await publicConfiguration.getGoogleTagsManagerKey();

                return HThirdPartyManager.register(
                    HStoragePolicyManager.Categories.ANALYTICS,
                    async () => {
                        await Utils.loadScript({
                            url: `https://www.googletagmanager.com/gtag/js?id=${gtmKey}`,
                            async: true,
                            defer: true,
                        });
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){ window.dataLayer.push(arguments); }
                        gtag('js', new Date());
                        gtag('config', gtmKey);
                        resolve(gtag);
                    },
                    'gtm-loader'
                );
            });

            return event.loadGoogleTagManagerPromise;
        };

        event.loadAptrinsicPromise = null;

        event.loadAptrinsic = () => {
            if (event.loadAptrinsicPromise) {
                return event.loadAptrinsicPromise;
            }

            event.loadAptrinsicPromise = new Promise(async (resolve, reject) => {
                const key = publicConfiguration.getAptrinsicKey();
                try {
                    if (!window.aptrinsic) {
                        window.aptrinsic = function (...args) {
                            (window.aptrinsic.q = window.aptrinsic.q || []).push(args);
                        };
                        window.aptrinsic.p = key;
                    }

                    await Utils.loadScript({
                        url: `https://web-sdk.aptrinsic.com/api/aptrinsic.js`,
                        queryParams: { a: key },
                        async: true,
                    });
                    resolve();
                } catch (error) {
                    console.error('Failed to load Aptrinsic:', error);
                    reject(error);
                }
            });

            return event.loadAptrinsicPromise;
        };

        event.loadFacebookPixelPromise = null;

        event.loadFacebookPixel = () => {
            if (event.loadFacebookPixelPromise) {
                return event.loadFacebookPixelPromise;
            }


            event.loadFacebookPixelPromise = new Promise(async (resolve, reject) => {
                const pixelId = publicConfiguration.getFacebookPixelId();
                return HThirdPartyManager.register(
                    HStoragePolicyManager.Categories.ANALYTICS,
                    async () => {
                        try {
                            if (!window.fbq) {
                                window.fbq = function (...args) {
                                    if (window.fbq.callMethod) {
                                        window.fbq.callMethod.apply(window.fbq, args);
                                    } else {
                                        window.fbq.queue = window.fbq.queue || [];
                                        window.fbq.queue.push(args);
                                    }
                                };

                                if (!window._fbq) {
                                    window._fbq = window.fbq;
                                }

                                window.fbq.push = window.fbq;
                                window.fbq.loaded = true;
                                window.fbq.version = '2.0';
                                window.fbq.queue = [];
                            }

                            await Utils.loadScript({
                                url: 'https://connect.facebook.net/en_US/fbevents.js',
                                async: true,
                            });

                            window.fbq('init', pixelId);
                            window.fbq('track', 'PageView');
                            resolve();

                        } catch (error) {
                            console.error('Failed to load Facebook Pixel:', error);
                            reject(error);
                        }
                    },
                    'facebook-pixel-loader'
                );
            });

            return event.loadFacebookPixelPromise;
        };

        event.setGlobalContext = function (data) {
            event.loadAptrinsic().then(function () {
                typeof aptrinsic != "undefined" && aptrinsic('set', 'globalContext', data)
            })
        }

        event.watchForms = function() {

            if(!isAnalyticsEnabled() || publicConfiguration.analytics["enable-form-analytics"]!==true) {
                return; //save memory
            };

            var textFieldsSelector = 'input[type!=checkbox][type!=radio]:not(.select2-input, .select2-offscreen), textarea';
            var checkboxesSelector = 'input[type=checkbox]';
            var radioSelector = 'input[type=radio]';
            var buttons = 'button:not(.confirm, .cancel, .close), div[ng-click], div.btn';

            $(document).on('focus', textFieldsSelector, function() {
                event.formEvent(this, 'enter', 'input');
            });

            $(document).on('blur', textFieldsSelector, function() {
                event.formEvent(this, 'exit', 'input');
            });

            $(document).on('change', checkboxesSelector, function() {
                event.formEvent(this, 'change', 'checkbox');
            });

            $(document).on('change', radioSelector, function() {
                event.formEvent(this, 'change', 'radio');
            });

            $(document).on('click', buttons, function() {
                event.formEvent(this, 'click', 'button');
            });

        };
        event.formEvent = function(element, eventName, type, data) {

            if(!isAnalyticsEnabled() || publicConfiguration.analytics["enable-form-analytics"]!==true) {
                return; //save memory
            };

            element = $(element);
            var form = element.closest('h-form');
            var view = '';

            if(!form) {
                //nearest form element
                form = element.closest('form');
                if(form) {
                    view = form.attr('action') ? form.attr('action') :
                        (
                            form.attr('name')?form.attr('name'):
                                (
                                    form.attr('id')?form.attr('id'):''
                                    )
                            );
                }
            } else {
                //h-form
                view = form.attr('view');
            }

            //element id
            var elementName = '';
            if(type!='button') {
                elementName = element.attr('name')?element.attr('name'):(
                    element.attr('id')?element.attr('id'):''
                );
            } else {
                elementName = $.trim(element.text());
            }


            var obj = {action: eventName, field: elementName, form:view, type:type, url:$location.path()};

            if(type == 'input') {
                var length = (element.val() || "").length;
                obj.length = length;
            } else if(type == 'checkbox') {
                obj.checked = (element.is(':checked') == true);
            } else if(type == 'radio') {
                obj.selected = element.val();
            }

            if(data) {
                for(var k in data) {
                    obj[k] = data[k];
                }
            }

            event.track('input', obj);
        };
        event.watchForms();

        event.loadTrackingScripts = () => {
            event.loadGoogleTagManager();
            event.loadAptrinsic();
            event.loadFacebookPixel();
        };

        event.loadTrackingScripts();

        return event;
    }]);
